import { request } from '@/libs/api-request'

export function getPluckShare (params, force) {
  let url = '/ba/pluck/share'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getPluckData (params, force) {
  let url = '/ba/pluck/get_data'

  const config = {
    method: 'post',
    url,
    data: {
      isPluck: true,
      ...params
    }
  }

  return request(config, force)
}
